// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3bEH0","productName":"Table_productName__B0ARe"};